import PropTypes from 'prop-types';
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Grid, MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import Chart from 'react-apexcharts';
import MainCard from '../MainCard';
import { gridSpacing } from '../../../store/constant';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import DataCard from './DataCard';
import axios from "../../../components/axios";
import StickyHeadNoPaginationTable from '../../components/Table/StickyHeadNoPaginationTable';



const PieChart = ({ series, total, pass, fail, skip, fullQuery, isShareable, shareAPI, testSuiteList, mapSuiteChart, setTotal, setPass, setFail, setSkip, setSeries, testSuite, setTestSuite, suiteRows, imageName }) => {
    const navigate = useNavigate();
    const [showTable, setshowTable] = useState(true);
    function handleTestSuite(e) {
          if (e.target.value === 'All Suites'){
            setshowTable(true);
          }else{
            setshowTable(false);
          }
          setTestSuite(e.target.value);
          setTotal(mapSuiteChart.get(e.target.value).total_count);
          setPass(mapSuiteChart.get(e.target.value).pass_count);
          setFail(mapSuiteChart.get(e.target.value).fail_count);
          setSkip(mapSuiteChart.get(e.target.value).skip_count);
          setSeries([mapSuiteChart.get(e.target.value).pass_count, mapSuiteChart.get(e.target.value).fail_count, mapSuiteChart.get(e.target.value).skip_count]);
    };

    const chartData = {
        width: 500,
        type: 'pie',
        options: {
            labels: ['PASS', 'FAIL', 'SKIP'],
            colors: ["#26A69A","#C10015", "#F2C037"],
            theme: {
                background: '#ffffff',
            },
            stroke:{
                colors:['transparent']
            },
            legend: {
                position: 'bottom',
                fontSize: '16px',
            },
            title: {
                text: testSuite,
                align: 'left'
            },
            chart: {
              events: {
                dataPointSelection: (event, chartContext, config) => {
                  if ( isShareable ){
                      handleShareLink(config.w.config.labels[config.dataPointIndex],fullQuery)
                  }
                }
              }
            }
        },
        series: series,
    };

    const columns = [
      { id: 'suite_name', align: 'center', label: 'Suite Name'},
      { id: 'total_count', align: 'center', label: 'Total'},
      { id: 'pass_count', align: 'center', label: 'Pass'},
      { id: 'fail_count', align: 'center', label: 'Fail'},
      { id: 'skip_count', align: 'center', label: 'Skip'},
    ];

    const handleShareLink = (status, fullQuery) => {
        if ( isShareable ) {
          if ( testSuiteList && testSuite !== 'All Suites' ) {
            alert('Select "All Suites" to show data with specific test result!');
            return
          }
          axios.post("/peloton/v1/automation/"+status+"/"+shareAPI,fullQuery,{withCredentials: true})
            .then(response => {
              if (response.data.message === "success") {
                  window.open(response.data.url, "_blank", "noreferrer");
              }else{
                alert(response.data.message);
              }
            }).catch(function(err){
              if (!err.response){
                alert(err);
              }else{
                if (err.response.status === 401){
                  navigate("/");
                }else{
                  console.log('error.response.status: ', err.response.status);
                  console.log('error.response.status: ', err.response.data.message);
                  alert(err.response.data.message);
                }
              }
            })
        }
      };

    return (
        <>
                <MainCard>
                {testSuiteList && (<FormControl variant="filled" sx={{ width: '100%'}}>
                  <InputLabel id="label-suite">Select Suite Name</InputLabel>
                    <Select
                      sx={{ backgroundColor: '#E3F2FD', fontFamily: '"Roboto", "sans-serif"', fontSize: "20px", }}
                      id="emmc_data"
                      fullWidth
                      value={testSuite}
                      onChange={handleTestSuite}
                      variant="filled"
                    >
                      {testSuiteList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>)}
                    <Grid container spacing={gridSpacing} style={{ marginTop: '8px'}}>
                    <Grid container columnSpacing={{ xs: 3, sm: 3, md: 3 }} >
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}>
                          <DataCard item='TOTAL' itemValue={total} isShareable={isShareable} handleShareLink={handleShareLink} fullQuery={fullQuery} color='#06539e' colorLight='#81d4fa' colorHover='#66b8de' icon={<SummarizeIcon width="28" height="28" />}/>
                        </Grid>
                        <Grid item xs={2}>
                          <DataCard item='PASS' itemValue={pass} isShareable={isShareable} handleShareLink={handleShareLink} fullQuery={fullQuery} color='#047a6f' colorLight='#9be0b1' colorHover='#83c799' icon={<CheckCircleOutlineIcon width="28" height="28" />}/>
                        </Grid>
                        <Grid item xs={2}>
                          <DataCard item='FAIL' itemValue={fail} isShareable={isShareable} handleShareLink={handleShareLink} fullQuery={fullQuery} color='#c10015' colorLight='#f2acb4' colorHover='#db939b' icon={<CancelOutlinedIcon width="28" height="28" />}/>
                        </Grid>
                        <Grid item xs={2}>
                          <DataCard item='SKIP' itemValue={skip} isShareable={isShareable}handleShareLink={handleShareLink} fullQuery={fullQuery} color='#e8b11c' colorLight='#f7eccb' colorHover='#f2dfa5' icon={<SkipNextIcon width="28" height="28" />}/>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={10}>
                          <Chart {...chartData} />
                        </Grid>
                        <Grid item xs={12} >
                        { showTable && (<StickyHeadNoPaginationTable rows={suiteRows} columns={columns} imageName={imageName}/>)}
                        </Grid>
                      </Grid>
                </MainCard>
        </>
    );
};

PieChart.propTypes = {
    series: PropTypes.array,
    total: PropTypes.number,
    pass: PropTypes.number,
    fail: PropTypes.number,
    skip: PropTypes.number,
};

export default PieChart;
